import styled from 'styled-components'
import { theme } from '../../../../style/theme'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const PickupMonitorCardWrap = styled.div`
	font-size: 1rem;
	display: flex;
	flex-direction: column;
	min-height: 19.06em;
	padding: 0.75em 1.25em;
	align-items: center;
	gap: 1.25em;
	border-radius: 0.75em;

	&.awaiting-pickup {
		border: 3px solid ${colorTheme.pickupMonitor.card.awaitingPickup.border};
		background: ${colorTheme.pickupMonitor.card.awaitingPickup.background};
	}

	&.processing-pickup {
		border: 3px solid ${colorTheme.pickupMonitor.card.processingPickup.border};
		background: ${colorTheme.pickupMonitor.card.processingPickup.background};
	}
`
PickupMonitorCardWrap.displayName = 'PickupMonitorCardWrap'

export const PickupMonitorCardHeader = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.94em;
`
PickupMonitorCardHeader.displayName = 'PickupMonitorCardHeader'

export const PickupMonitorCardOrderNumberWrap = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.31em;
`
PickupMonitorCardOrderNumberWrap.displayName = 'PickupMonitorCardOrderNumberWrap'

export const PickupMonitorCardOrderNumberLabel = styled.div`
	display: flex;
	padding: 0.13em 0.63em;
	align-items: center;
	gap: 0.31em;
	border-radius: 0.63em;
	min-height: 2.06em;

	&.order-day-counter {
		background: ${colorTheme.pickupMonitor.card.orderNumber.background};
	}

	&.platform {
		border: 1px solid ${colorTheme.pickupMonitor.card.orderNumber.platform.border};
		background: ${colorTheme.pickupMonitor.card.orderNumber.platform.background};
	}
`
PickupMonitorCardOrderNumberLabel.displayName = 'PickupMonitorCardOrderNumberLabel'

export const PickupMonitorCardOrderNumberText = styled.div`
	font-family: ${theme.fontRobotoBold};
	font-size: 1.25em;
	font-weight: 700;
	color: ${colorTheme.pickupMonitor.card.orderNumber.text};

	&.platform {
		color: ${colorTheme.pickupMonitor.card.orderNumber.platform.text};
	}
`
PickupMonitorCardOrderNumberText.displayName = 'PickupMonitorCardOrderNumberText'

export const PickupMonitorCardOrderPlatformIcon = styled.div`
	font-size: 1em;

	> svg {
		width: 5em;
		height: 1.06em;
	}

	> .WOLT_PLUGIN-LIGHT, .WOLT_PLUGIN-DARK {
		width: 3.3em;
		height: 1.5em;
	}

	> .kiosk-LIGHT, .kiosk-DARK  {
		width: 5em;
		height: 1.2em;
	}
`
PickupMonitorCardOrderPlatformIcon.displayName = 'PickupMonitorCardOrderPlatformIcon'

export const PickupMonitorCardInfoWrap = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.63em;
`
PickupMonitorCardInfoWrap.displayName = 'PickupMonitorCardInfoWrap'

export const PickupMonitorCardCustomerName = styled.div`
	color: ${colorTheme.pickupMonitor.card.customerName};
	font-family: ${theme.fontRobotoBold};
	font-size: 0.88em;
	font-weight: 500;
`
PickupMonitorCardCustomerName.displayName = 'PickupMonitorCardCustomerName'

export const PickupMonitorCardPayment = styled.div`
	display: flex;
	align-items: center;
	gap: 0.31em;

	> svg {
		width: 1.06em;
		height: 1.06em;
		flex-shrink: 0;
		fill: ${colorTheme.pickupMonitor.card.paymentIcon};
	}
`
PickupMonitorCardPayment.displayName = 'PickupMonitorCardPayment'

export const PickupMonitorCardPaymentTotal = styled.div`
	color: ${colorTheme.pickupMonitor.card.total};
	font-family: ${theme.fontRobotoBold};
	font-size: 1em;
	font-weight: 500;
`
PickupMonitorCardPaymentTotal.displayName = 'PickupMonitorCardPaymentTotal'

export const PickupMonitorCardFooter = styled.div`
	margin-top: auto;
	display: flex;
	align-items: center;
	width: 100%;
	gap: 0.63em;
`
PickupMonitorCardFooter.displayName = 'PickupMonitorCardFooter'
